import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import moment from 'moment-timezone';

moment.locale('es');

const EventOpenDoorList = ({ eventOpenDoors = [] }) => {
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const openPhotoModal = (photoUrl) => {
    setSelectedPhoto(photoUrl);
    setShowPhotoModal(true);
  };

  const closePhotoModal = () => {
    setSelectedPhoto(null);
    setShowPhotoModal(false);
  };

  return (
    <div className="mt-3 p-0 table-users">
      <table className="table table-striped">
        <thead className="text-center font-weight-bold">
          <tr>
            <th scope="col">Imagen</th>
            <th scope="col">Fecha y hora</th>
            <th scope="col">Puerta</th>
            <th scope="col">Residente</th>
            <th scope="col">Origen</th>
            <th scope="col">Apto</th>
            <th scope="col">Edificio</th>
          </tr>
        </thead>
        <tbody>
          {eventOpenDoors.map((eventOpenDoor) => {
            const {
              id,
              image_url,
              timestamp_camera,
              timestamp_event,
              created_at,
              doorName,
              userName,
              origin,
              eventOrigin,
              apartment,
              buildingName,
            } = eventOpenDoor;

            const rawOrigin = origin || eventOrigin;
            let displayOrigin = '';
            if (rawOrigin === 'APP') {
              displayOrigin = 'Aplicación';
            } else if (rawOrigin === 'PHYSICAL') {
              displayOrigin = 'Lectora (Tag)';
            } else if (rawOrigin) {
              displayOrigin = rawOrigin;
            }

            const rawDate = timestamp_camera || timestamp_event || created_at;
            const displayDate = rawDate ? moment(rawDate).format('DD MMM YYYY hh:mm A') : '';

            return (
              <tr key={id}>
                <td data-label="Imagen" className="align-middle">
                  {image_url ? (
                    <button type="button" className="btn" onClick={() => openPhotoModal(image_url)}>
                      Ver foto
                    </button>
                  ) : (
                    'Sin foto'
                  )}
                </td>
                <td data-label="Fecha y hora" className="align-middle">
                  {displayDate}
                </td>
                <td data-label="Puerta" className="align-middle">
                  {doorName || ''}
                </td>
                <td data-label="Residente" className="align-middle">
                  {userName || ''}
                </td>
                <td data-label="Origen" className="align-middle">
                  {displayOrigin}
                </td>
                <td data-label="Apto" className="align-middle">
                  {apartment || ''}
                </td>
                <td data-label="Edificio" className="align-middle">
                  {buildingName || ''}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Modal
        open={showPhotoModal}
        onClose={closePhotoModal}
        center
        classNames={{ overlay: 'background-modal', modal: 'customModal' }}
      >
        <div
          className="modal-content"
          style={{
            backgroundColor: '#00bfdf',
            borderRadius: '15px',
            padding: '10px',
            maxWidth: '700px',
            maxHeight: '700px',
            boxSizing: 'border-box',
          }}
        >
          <button type="button" className="button-close" onClick={closePhotoModal}>
            <span aria-hidden="true" className="button-span">
              &times;
            </span>
          </button>

          {selectedPhoto ? (
            <img
              src={selectedPhoto}
              alt="Imagen evento OPEN_DOOR"
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '10px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                marginTop: '20px',
              }}
            />
          ) : (
            <span
              style={{
                color: 'white',
                marginTop: '40px',
              }}
            >
              No hay foto disponible
            </span>
          )}
        </div>
      </Modal>
    </div>
  );
};

EventOpenDoorList.propTypes = {
  eventOpenDoors: PropTypes.array,
};

export default EventOpenDoorList;
